export default function (store, config) {
    const match = typeof config?.match === "string" ? config.match.trim() : null;
    const by = typeof config?.by === "string" ? config.by.trim() : null;
    let filter = { match, by, ...config };
    if (!config || !match?.length) {
        filter = null;
    }
    store.setState({ filter });
}
//# sourceMappingURL=filter.js.map